module.exports = __webpack_public_path__ + "img/4.58218c95.jpg";